import { DxContainer } from '@dvag/design-system-react';
import { HouseholdInterface, SelectedHousehold } from 'type/household';
import { useViewHousehold } from '../hooks/useViewHousehold';
import { Household } from './household/Household';
import { Loading } from './Loading';

import './style.css';

interface HouseholdListProps {
  households: HouseholdInterface[];
  isLoading: boolean;
  setSelectedHouseHold: (data: SelectedHousehold) => void;
}

export const HouseholdList = ({
  households,
  isLoading,
  setSelectedHouseHold,
}: HouseholdListProps) => {
  const { mutateAsync: viewHousehold } = useViewHousehold();

  if (isLoading) {
    return <Loading />;
  }

  return households?.length ? (
    <DxContainer
      className="customer-result-list"
      color="white"
      data-testid="household-list-container"
      role="list"
    >
      {households.map((household) => {
        const { personList, address, householdId } = household;

        return (
          <Household
            address={address}
            data-testid={`view-household-${householdId}`}
            key={householdId}
            onClick={() => {
              setSelectedHouseHold({ householdId, personList });
              viewHousehold(householdId);
            }}
            personList={personList}
          />
        );
      })}
    </DxContainer>
  ) : null;
};
